<template>
  <ValidationObserver ref="religion">
    <div>
      <h2 class="mb-5">
        What is your religion?
      </h2>
    </div>
    <div v-if="isFetchingReligions">
      <v-skeleton-loader type="list-item-three-line" />
    </div>
    <ValidationProvider
      v-slot="{ errors }"
      name="religion"
      rules="required"
      v-else
    >
      <RadioButton
        v-model="religion"
        @select="val => (religion = val)"
        :options="options"
        mixed
        :selectedValue="religion"
        :errorMessages="showValidationErrors ? errors : ''"
      />
    </ValidationProvider>

    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        Continue
      </PrimaryButton>
    </div>
  </ValidationObserver>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { createNamespacedHelpers } from "vuex";
import { FETCH_RELIGIONS } from "@/store/modules/data/actions";
import {
  GET_RELIGIONS,
  GET_IS_FETCHING_RELIGIONS
} from "@/store/modules/data/getters";
import { map } from "lodash";
import RadioButton from "@/components/common/RadioButton";
import {
  includePreferNotSayOption,
  getFormattedValue
} from "@/views/profile/QuestionsAndAnswers/steps/Diversity/utils";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const { mapGetters, mapActions } = createNamespacedHelpers(DATA_NAMESPACE);

export default {
  name: "Religion",
  components: {
    PrimaryButton,
    RadioButton,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    isLoading: Boolean,
    userDiversityTraits: Object
  },
  created() {
    this.fetchReligions();
  },
  data() {
    return {
      showValidationErrors: false,
      religion: this.userDiversityTraits.religion
    };
  },
  computed: {
    options() {
      const fetchedOptions = map(this.religions, ({ name }) => ({
        label: name,
        value: name
      }));
      return includePreferNotSayOption(fetchedOptions);
    },
    ...mapGetters({
      religions: GET_RELIGIONS,
      isFetchingReligions: GET_IS_FETCHING_RELIGIONS
    })
  },
  methods: {
    ...mapActions({
      fetchReligions: FETCH_RELIGIONS
    }),
    async nextStep() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.religion.validate();
      if (isValid) {
        this.$emit("nextStep", {
          data: { religion: getFormattedValue(this.religion) },
          dataType: "divirsityTraits"
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>
